import {
  Button,
  Card,
  Col,
  Descriptions,
  Empty,
  Row,
  Skeleton,
  Space,
} from "antd";
import React from "react";
import { Location } from "../../../../constants/serve";

type LocationsProps = {
  locations: Location[];
  onRefresh: (nextLocations: Location[]) => void;
  onClick?: (location: Location) => void;
};

const Locations: React.FC<LocationsProps> = ({
  locations,
  onClick,
  onRefresh,
}) => {
  if (locations.length === 0) {
    return <Empty description="没有位置信息" />;
  }

  const onDeleteSuccess = (deleted: Location[]) => {
    const ids = deleted.map((d) => d.id);
    let nextLocations = locations.filter((l) => ids.indexOf(l.id) === -1);
    onRefresh(nextLocations);
  };

  const onAddSucces = (location: Location) => {
    const nextLocations = [location].concat(locations);
    onRefresh(nextLocations);
  };

  const onUpdateSucces = (location: Location) => {
    const nextLocations = [location].concat(
      locations.filter((l) => l.id !== location.id)
    );
    onRefresh(nextLocations);
  };

  const groups = new Map<string, Location[]>();
  let pairs: string[] = [];
  locations.forEach((l) => {
    const { pair } = l;
    let ext = groups.get(pair);
    if (ext === undefined) {
      pairs.push(pair);
      ext = new Array<Location>();
    }
    ext.push(l);
    groups.set(pair, ext);
  });

  const views: any[] = [];
  let index = 1;
  pairs = pairs.sort((a, b) => a.localeCompare(b));
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i];
    const locations = groups.get(pair)!!;
    views.push(
      <Col key={"col-" + pair} xl={12} xxl={8} sm={24}>
        <LocationGroup
          key={pair}
          onClick={onClick}
          pair={pair}
          locations={locations}
          index={index++}
          onAddSuccess={onAddSucces}
          onUpdateSuccess={onUpdateSucces}
          onDeleteSuccess={onDeleteSuccess}
        /></Col>
    );
  }

  return (
    <div className="flex flex-center">
      <Row gutter={[8, 16]}>
        {views}
      </Row>
      {/* <Space size={[8, 16]} wrap={true}>{views}</Space> */}
    </div>
  );
};

type LocationGroupProps = {
  pair: string;
  index: number;
  locations: Location[];
  onClick?: (location: Location) => void;
  onAddSuccess: (location: Location) => void;
  onUpdateSuccess: (location: Location) => void;
  onDeleteSuccess: (locations: Location[]) => void;
};
const LocationGroup: React.FC<LocationGroupProps> = ({
  pair,
  index,
  onClick,
  locations,
  onAddSuccess,
  onUpdateSuccess,
  onDeleteSuccess,
}) => {
  let hasStarting = locations.find((x) => x.type === 0);
  let hasDestination = locations.find((x) => x.type === 1);

  const [sp, setSp] = React.useState(false);
  const [showAdd, setShowAdd] = React.useState(false);


  const buttons = [
  ];

  if (!hasStarting) {
    buttons.push(
      <Button
        key={`add-${pair}-starting`}
        type="primary"
        onClick={() => setShowAdd(true)}
      >
        补充起始地
      </Button>
    );
  }

  if (!hasDestination) {
    buttons.push(
      <Button
        key={`add-${pair}-destination`}
        type="primary"
        onClick={() => setShowAdd(true)}
      >
        补充送达地
      </Button>
    );
  }


  const onUpdateComplete = async (l: Location) => {
    /*  setSp(true);
 
     try {
       const res = await R.updateLocationPair<Location>(sid, l);
       setSp(false);
       if (res.error !== "") {
         throw new Error(res.error);
       }
 
       notification.success({
         message: hasDestination ? "更新起始地成功" : "更新送达地成功",
       });
       onUpdateSuccess(res.result);
     } catch (e) {
       setSp(false);
       notification.error({
         message: hasDestination ? "更新起始地失败" : "更新送达地失败",
         description: `错误信息: ${e}`,
       });
     } */
  };

  const locationViews = locations
    .sort((a, b) => a.type - b.type)
    .map((l, i) => (
      <Renderer
        location={l}
        onClick={onClick}
        key={"loca-" + i}
        onUpdate={onUpdateComplete}
      />
    ));

  return (
    <div key={pair} className="flex-1">
      <Skeleton loading={sp}>
        <Card title={`位置组 - ${index}`} extra={<Space>{buttons}</Space>}>
          {/* <Descriptions title="位置组信息"> */}
          {locationViews}
          {/* </Descriptions> */}
        </Card>
      </Skeleton>

    </div>
  );
};

type RendererProps = {
  location: Location;
  onUpdate: (location: Location) => void;
  onClick?: (location: Location) => void;
};
const Renderer: React.FC<RendererProps> = ({ location, onClick, onUpdate }) => {
  const onLocationClick = () => {
    if (onClick !== undefined) {
      onClick(location);
    }
  };
  const typeText = ["起始地", "送达地"][location.type];
  return (
    <Descriptions>
      <Descriptions.Item label={typeText}>
        <div
          style={{ textDecoration: "underline", cursor: "pointer" }}
        // onClick={onLocationClick}
        >
          {location.address} {location.name}
        </div>
      </Descriptions.Item></Descriptions>);
};

export default Locations;
